module.exports = __webpack_public_path__ + "static/media/img404.b6f6b911.png";